import { useParams } from "react-router";
import { CaseDetail } from "@/features/case-management/CaseDetail";

export function CaseDetailPage() {
  const { id } = useParams<{ id: string }>();

  if (!id) {
    return (
      <div className="space-y-4">
        <h1 className="text-2xl font-bold text-foreground">Case not found</h1>
        <p className="text-muted-foreground">No case ID provided.</p>
      </div>
    );
  }

  return <CaseDetail caseId={id} />;
}
